import {api} from "../../api";
import {handleResponse, RequestOptions} from "../types";
import {getCookie} from "../../helpers/utils";
import { cookieSupervision, cookieToken } from "../../constants";
import { ListPayloadType } from "../../store/affiliate/offers";

const getFilters = () => {
  const authenticity_token = getCookie(cookieToken);
  const isSupervision = JSON.parse(getCookie(cookieSupervision));

  const endpoint = isSupervision ? api.supervision.offers.filters : api.affiliate.offers.filters;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : null}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getList = (data: ListPayloadType) => {
  const isSupervision = JSON.parse(getCookie(cookieSupervision));
  const authenticity_token = getCookie(cookieToken);

  const endpoint = isSupervision ? api.supervision.offers.list : api.affiliate.offers.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const sendOfferRequest = (data: any) => {
  const isSupervision = JSON.parse(getCookie(cookieSupervision));
  const authenticity_token = getCookie(cookieToken);

  const endpoint = isSupervision ? api.supervision.offers.request : api.affiliate.offers.request;

  const payload = {
    offer_id: data.id,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};


export const offersService = {
  getFilters,
  getList,
  sendOfferRequest,
};
